import React from "react";
import banner from "../../../assets/images/logo-white.svg";

export default function Banner() {
  return (
    <div className="flex justify-center items-center bg-karimjee h-20">
      <img src={banner} alt="" className="w-32" />
    </div>
  );
}
